// Native
import { useState } from "react"

// Components
import { AlertDialogBody, AlertDialogFooter, Button, ButtonGroup, Divider, useDisclosure, useToast } from "@chakra-ui/react"
import { Alert, Dialog, Form } from "components"

// Config
import { Mask } from "config"

// Hooks
import { useWithdraw, useWithdraws } from "hooks"

// Screens
import { Authenticate } from "screens"
import { API } from "config"

export default function Reject({ data, ...props}){
    
    const toast = useToast()
    const auth = useDisclosure()
    const withdraw = useWithdraw(data?.id)
    const withdraws = useWithdraws(1)
    const [ rejected_reason, setRejectedReason ] = useState()
    const [ loading, setLoading ] = useState(false)
    const isEnabled = rejected_reason?.length >= 5

    const handleSubmit = async () => {
        if(!isEnabled) return
        setLoading(true)

        try{
            await API.put(`/withdraws/${withdraw.data?.id}/reject`, { rejected_reason })
            toast({ title: 'O pedido de saque foi rejeitado', status: 'info' })
            withdraw.refetch()
            withdraws.refetch()
            props?.onClose()
            setRejectedReason(null)
        }catch(err){
            toast({ title: 'Não foi possível rejeitar o saque agora.', description: err?.response?.data?.message, status: 'warning' })
        }

        setLoading(false)
    }

    return(
    <>
    <Dialog title={`Rejeitar pedido de saque #${withdraw.data?.cod}?`} loading={loading} {...props}>
        <AlertDialogBody fontSize="sm">
            <Alert status="warning" title="Atenção!" children="Você está prestes a rejeitar um pedido de saque. Esta ação é irreversível." mb={6} />

            Tem certeza que deseja rejeitar o pedido de saque no valor de <strong>R$ {Mask.price(withdraw.data?.value)}</strong> de <strong>{withdraw.data?.consultant?.customer?.name}</strong>? Ao continuar, o pedido será cancelado e o valor retornado 
            à conta do consultor.

            <Divider my={4} />

            <Form.Textarea
                required
                label="Motivo do cancelamento:"
                value={rejected_reason}
                onChange={e => setRejectedReason(e.target.value)}
                isDisabled={loading}
                helper="É obrigatório informar o motivo pelo qual o saque foi rejeitado. Estas informação aparacerá para o cliente."
                placeholder="Ex.: Este saque foi rejeitado porque..."
            />
        </AlertDialogBody>
        <AlertDialogFooter>
            <ButtonGroup size="sm" isDisabled={loading}>
                <Button children="Rejeitar saque" isLoading={loading} isDisabled={!isEnabled} onClick={auth.onOpen} />
                <Button colorScheme="red" children="Cancelar" onClick={props.onClose} />
            </ButtonGroup>
        </AlertDialogFooter>
    </Dialog>

    {/* Screens */}
    <Authenticate {...auth} onSuccess={handleSubmit} />
    </>
    )
}